import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setSerendipityActionInContext, getSerendipityAction } from 'modules/serendipity/actions';
import { setNarrativeAsCompleted } from 'routes/Narratives/modules';
import Narrative from '../components';


function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.narrative,
    actualContext: state.steps.context,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setSerendipityActionInContext: bindActionCreators(setSerendipityActionInContext, dispatch),
    getSerendipityAction: bindActionCreators(getSerendipityAction, dispatch),
    setNarrativeAsCompleted: bindActionCreators(setNarrativeAsCompleted, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Narrative));



// WEBPACK FOOTER //
// ./src/components/Narrative/container/index.js